import React, { useEffect } from "react";
import FormFields from "./FormFields";
import { useFormContext } from "react-hook-form";

function AccordionField(props) {
  const { formState: { errors } } = useFormContext();

  useEffect(() => {
    const handleShown = (event) => {
      const accordionCollapse = event.target;
      const accordionItem = accordionCollapse.closest('.accordion-item');
      const modalBody = accordionCollapse.closest('.modal-body');

      if (accordionItem && modalBody) {
        const header = accordionItem.querySelector('.accordion-header');
        const headerOffset = header.offsetTop;
        // console.log("headerOffset:", headerOffset);

        modalBody.scrollTo({
          top: headerOffset - 10, // Adjust scroll offset if needed
          behavior: 'smooth',
        });
        // console.log("modalBody height:", modalBody.clientHeight);
        // console.log("accordion header offsetTop:", header.offsetTop);
      }
      
    };

    const collapseElements = document.querySelectorAll('.accordion-collapse');

    collapseElements.forEach(el => {
      el.addEventListener('shown.bs.collapse', handleShown);
    });

    return () => {
      collapseElements.forEach(el => {
        el.removeEventListener('shown.bs.collapse', handleShown);
      });
    };
  }, [props.sections]);

  // Existing error handling effect
  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      props.sections?.forEach((section, index) => {
        const hasError = section.fields?.some(field => 
          errors[field.name] || 
          (field.fields && field.fields.some(subField => errors[subField.name]))
        );

        if (hasError) {
          const accordionButton = document.querySelector(`[data-bs-target="#collapse-${index}"]`);
          const accordionCollapse = document.querySelector(`#collapse-${index}`);
          
          if (accordionButton && !accordionButton.classList.contains('show')) {
            accordionButton.classList.remove('collapsed');
            accordionCollapse.classList.add('show');
          }
        }
      });
    }
  }, [errors, props.sections]);

  return (
    <div className="col-12 mb-3">
      {props.text && <small>{props.text}</small>}
      <div className="accordion mt-2" id="accordionExample">
        {props.sections?.map(
          (section, index) =>
            section.isShow && (
              <div className="accordion-item" key={index}>
                <div className="accordion-header" id={`heading-${index}`}>
                  <a
                    className="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse-${index}`}
                    aria-expanded="true"
                    aria-controls={`collapse-${index}`}
                  >
                    <div>
                      <h6 className="mb-0">{section.title}</h6>
                      {section?.subtitle && <small>{section.subtitle}</small>}
                    </div>
                  </a>
                </div>
                <div
                  id={`collapse-${index}`}
                  className="accordion-collapse collapse"
                  aria-labelledby={`heading-${index}`}
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <div className="row">
                      <FormFields fields={section.fields} />
                    </div>
                  </div>
                </div>
              </div>
            )
        )}
      </div>
    </div>
  );
}

export default AccordionField;